import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, VStack } from "native-base";
import { useEffect } from "react";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../form/SubmitButton";
import Button from "../atoms/Button";
import ModalContent from "../molecules/ModalContent";
import FormSelect from "../form/FormSelect";
import FormControl from "../form/FormControl";
const InsulinProtocolModalForm = ({ onClose, onSubmitPress, isSuccess, }) => {
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const { t } = useTranslation();
    const protocolTypes = [
        { value: "daily1", label: "Napi 1x" },
        { value: "daily2", label: "Napi 2x (10:00, 18:00)" },
        { value: "daily3", label: "Napi 3x (reggel, délben, este)" },
        { value: "weekly2", label: "Heti 2x (hétfő, csütörtök)" },
        { value: "weekly3", label: "Heti 3x (hétfő, szerda, szombat)" },
    ];
    return (_jsx(ModalContent, Object.assign({ header: t("measures:insulinProtocolSetup"), footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, label: t("save") })] }) }, { children: _jsxs(VStack, Object.assign({ overflowY: "clip" }, { children: [_jsx(HStack, Object.assign({ mt: 2 }, { children: _jsx(FormSelect, { choices: protocolTypes, name: "type", label: t("measures:protocol"), isRequired: true, labelProps: { _text: { color: "gray.800" } } }) })), _jsx(Box, Object.assign({ mt: 2 }, { children: _jsx(FormControl, { label: t("measures:protocolDescription"), name: "instructions", labelProps: {
                            _text: { color: "gray.800" },
                        }, maxLength: 100, height: 35, multiline: true, isRequired: true }) }))] })) })));
};
export default InsulinProtocolModalForm;
